import React from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  Stack,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  TextField,
  Breadcrumbs,
  Link,
  Button,
  InputAdornment,
} from "@mui/material";
import Pagination from "@mui/material/Pagination";
import SearchIcon from "@mui/icons-material/Search";
import { useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";

const TableComponent = ({
  FiltersJsx,
  columns,
  rows,
  CountryJsx,
//   handleRowDoubleClick,
  handleSearchChange,
  handleChangePage,
  handleChangeRowsPerPage,
  handleClick,
  handleHomeClick,
  handleLocationclick,
  filteredRows,
  title,
  titleMaster,
  handleIconClick,

}) => {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(15);
  const location = useLocation();
  const permissions = location.state?.permissions || [];

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleLocationNavigation = () => {
    handleLocationclick(permissions);
  };

  const totalPages = Math.ceil(filteredRows.length / rowsPerPage);

  return (
    <Box
      sx={{
        maxWidth: "100vw",
        overflowX: "hidden",
        backgroundColor: "#f9f9f9",
        minHeight: "100vh",
      }}
    >
      <ToastContainer />
      <Box
        sx={{
          backgroundColor: "#ffffff",
          padding: "12px 32px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          boxShadow: "0 2px 10px rgba(0, 0, 0, 0.05)",
          borderRadius: "12px",
          margin: "10px auto",
          maxWidth: "95%",
        }}
      >
     

        {/* <FaFileExcel style={{ position: 'relative', left: '280px', color: 'green', fontSize: '30px' }}/> */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
            gap: "16px",
            minWidth: "300px",
          }} 
        >
          {FiltersJsx ? FiltersJsx : null}
        
       
         
        </Box>
       
      </Box>
        {/* Heading for Track Ticket */}
        <Typography variant="h5" align="center" sx={{  paddingTop:'25px',  }}>
           Ticket Data
            </Typography>
       
      <Paper
        sx={{
          width: "90%",
          overflow: "hidden",
          margin: "10px auto", // Center the Paper
          backgroundColor: "#ffffff",
          borderRadius: "12px",
          boxShadow: "0 2px 10px rgba(0, 0, 0, 0.05)",
          padding: "20px",
        }}
      >
        <TableContainer sx={{ maxHeight: 450 }}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow sx={{ "& > th": { padding: "12px" } }}>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    sx={{
                      backgroundColor: "#dddbff",
                      color: "#333",
                      fontWeight: "600",
                      padding: "4px 2px 6px 5px !important",
                      border: "0.5px solid #ddd",
                      borderBottom: "2px solid #ddd",
                    }}
                  >
                    <Typography
                      variant="subtitle1"
                      fontWeight="bold"
                      sx={{ borderBottom: "0.5px solid #ddd" }}
                    >
                      {column.label}
                    </Typography>
                    <TextField
                      size="small"
                      variant="outlined"
                      placeholder={`Search ${column.label}`}
                      onChange={(e) =>
                        handleSearchChange(column.id, e.target.value)
                      }
                      sx={{
                        mt: 1,
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "8px",
                          backgroundColor: "#f9f9f9",
                          fontSize: "0.75rem",
                          height: "26px",
                          width:"120px",
                        },
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <SearchIcon
                              onClick={handleIconClick}
                              style={{ cursor: "pointer" }}
                            />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredRows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={index}
                    //   onDoubleClick={() => handleRowDoubleClick(row)}
                      sx={{
                        "& > td": {
                          padding: "3px",
                          border: "0.5px solid #ddd",
                        },
                        "&:hover": {
                          backgroundColor: "#f1f1f1",
                          cursor: "pointer",
                        },
                        transition: "background-color 0.3s ease",
                      }}
                    >
                      {CountryJsx && <CountryJsx row={row} ind={index} />}
                      {CountryJsx
                        ? columns.slice(1).map((column) => {
                            const value = row[column.id];
                            
                            return (
                              <TableCell key={column.id} align={column.align} >
                                {value}
                              </TableCell>
                            );
                          })
                        : columns.map((column) => {
                            const value = row[column.id];
                           
                            return (
                              <TableCell key={column.id} align={column.align} >
                                {value}
                              </TableCell>
                            );
                          })}
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[15, 30, 50, 100, 250, 500, 1000]}
          component="div"
          count={filteredRows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          handlePageChange={handlePageChange}
          onPageChange={(event, newPage) => handlePageChange(newPage)}
          onRowsPerPageChange={(event) => {
            const newRowsPerPage = parseInt(event.target.value, 10);
            setRowsPerPage(newRowsPerPage);
            setPage(0);
          }}
          sx={{
            backgroundColor: "#dddbff",
            borderTop: "1px solid #ddd",
            color: "#333",
            borderRadius: "0 0 12px 12px",
            "& .MuiToolbar-root": {
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              width: "100%",

              flexWrap: "wrap",
            },
            "& .MuiTablePagination-displayedRows": {
              display: "none",
            },
            "& .MuiTablePagination-actions": {
              display: "none",
            },

            "& .MuiTablePagination-selectLabel": {
              marginBottom: 2,
            },
            "& .MuiTablePagination-select": {
              marginBottom: 0,
            },
          }}
          ActionsComponent={({ onPageChange }) => (
            <Stack
              // spacing={2}
              direction="row"
              alignItems="center"
              sx={{
                // flex: '1',
                justifyContent: "center",
                marginLeft: "16px",
              }}
            >
              <Pagination
                count={totalPages}
                page={page + 1}
                onChange={(event, newPage) => handlePageChange(newPage - 1)}
                showFirstButton
                showLastButton
                sx={{
                  "& .MuiPaginationItem-root.Mui-selected": {
                    backgroundColor: "#635bff",
                    color: "#ffffff",
                  },
                }}
              />
            </Stack>
          )}
        />
      </Paper>
      {rows.length === 0 && (
        <Box
          sx={{
            width: "90%",
            margin: "20px auto",
            display: "flex",
            justifyContent: "center",
            color: "red",
          }}
        >
          {/* <LinearProgress sx={{ borderRadius: '8px' }} /> */}
          No Record Found...
        </Box>
      )}
    </Box>
  );
};

export default TableComponent;
